import {observer} from "mobx-react-lite";
import React, {FormEvent} from "react";
import {MessageType, Modulator} from "../stores/Modulator";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPause, faPlay, faStop, faVolumeMute, faVolumeUp} from "@fortawesome/free-solid-svg-icons";
import {useStores} from "../hooks/useStores";

interface ModulatorHeaderProps {
    modulator: Modulator;           // "CC<CC>" by default
    index: number;
}

export const ModulatorHeader = observer(({modulator, index}: ModulatorHeaderProps) => {

    // console.log("ModulatorHeader render");

    const {modulatorsStore: modulators} = useStores();

    const updateModulatorName = (e: React.ChangeEvent<HTMLInputElement>) => {
        modulator.name = e.currentTarget.value;
    }

    const selectMessageType = (e: FormEvent<HTMLSelectElement>) => {
        if (["CC", "NRPN"].includes(e.currentTarget.value)) {
            modulator.messageType = e.currentTarget.value as MessageType;
        }
    }

    const selectMessageNumber = (e: FormEvent<HTMLSelectElement>) => {
        modulator.messageNumber = parseInt(e.currentTarget.value);
        // console.log("selectMessageNumber", parseInt(e.currentTarget.value), modulator.messageNumber);
    }

    const selectChannel = (e: FormEvent<HTMLSelectElement>) => {
        modulator.channel = parseInt(e.currentTarget.value, 10);
    }

    const play = () => {
        modulator.play();
    }
    const pause = () => {
        modulator.pause();
    }
    const stop = () => {
        modulator.stop();
    }

    const mute = () => {
        modulator.mute();
    }
    const unmute = () => {
        modulator.unmute();
    }

    const deleteMe = () => {
        modulators.deleteModulator(index);
    }

    return (
        <div className="row align-center mod-header">
            <input type="text" value={modulator.name} className="mod-name" onChange={updateModulatorName}/>
            <div>
                <select value={modulator.messageType} onChange={selectMessageType}>
                    <option value="CC">CC</option>
                    {/*<option value="NRPN">NRPN</option>*/}
                </select>
            </div>
            <div>
                <select value={modulator.messageNumber} onChange={selectMessageNumber}>
                    {[...Array(119)].map((_, i)=> <option key={i} value={i}>{i}</option>)}
                </select>
            </div>
            <div>
                channel: <select value={modulator.channel} onChange={selectChannel}>
                {[...Array(16)].map((_, i)=> <option key={i} value={i}>{i+1}</option>)}
            </select>
            </div>
            <div className="mod-transport">
                {!modulator.running && <button onClick={play}><FontAwesomeIcon icon={faPlay} /></button>}
                {modulator.running && <button onClick={pause}><FontAwesomeIcon icon={faPause} /></button>}
                <button onClick={stop}><FontAwesomeIcon icon={faStop} /></button>

                {modulator.muted && <button onClick={unmute}><FontAwesomeIcon icon={faVolumeUp} /></button>}
                {!modulator.muted && <button onClick={mute}><FontAwesomeIcon icon={faVolumeMute} /></button>}
            </div>
            <div className="value">
                current value: {modulator.output}
            </div>
            <div className="grow text-end">
                <button onClick={deleteMe}>delete</button>
            </div>
        </div>
    );

});
